import { render } from "./InstructionsDrawer.vue?vue&type=template&id=72be586f&scoped=true"
import script from "./InstructionsDrawer.vue?vue&type=script&lang=js"
export * from "./InstructionsDrawer.vue?vue&type=script&lang=js"

import "./InstructionsDrawer.vue?vue&type=style&index=0&id=72be586f&lang=scss&scoped=true"
import "./InstructionsDrawer.vue?vue&type=style&index=1&id=72be586f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72be586f"]])

export default __exports__